import kwPluginClient from './kwPluginClient.js';
import { buildMediaSourceResult } from './musicPluginProxy.js';

/**
 * 洛雪音乐「长青SVIP音源」脚本 - 酷我线路
 * 解析后端域名是 musicapi.haitangw.net，与现有 kwPluginClient
 * (music.haitangw.cc 主线路 / kw-api.cenguigui.cn 备用) 完全不同，因此作为独立音源呈现。
 *
 * 注意：与 kg/qq/wy 线路不同，该接口不会返回 JSON 或重定向，而是直接返回音频二进制流，
 * 即请求地址本身就是可播放地址。因此这里不通过 /api/proxy/forward 预取（那是JSON包装的
 * 通用代理，整段拉取二进制会非常慢且无意义），而是直接把地址交给 AudioController，
 * 由其识别为外部音乐地址后走 /api/audio/proxy/stream 真正的流式代理播放。
 */
const PLATFORM = 'lx-kw';
const SOURCE_TAG = 'lx-kw-plugin';

const LEVELS = {
  low: 'standard',
  standard: 'standard',
  high: 'exhigh',
  super: 'lossless'
};

async function search(query, page = 1) {
  const result = await kwPluginClient.search(query, page);
  return {
    ...result,
    data: result.data.map((song) => ({ ...song, source: SOURCE_TAG }))
  };
}

async function getMediaSource(musicItem, quality = 'high') {
  const songId = musicItem?.id || musicItem?.raw?.rid || musicItem?.raw?.id;
  if (!songId) {
    throw new Error('酷我歌曲ID不能为空');
  }

  const level = LEVELS[quality] || LEVELS.high;
  const audioUrl = `https://musicapi.haitangw.net/music1/kw.php?type=mp3&id=${songId}&level=${level}`;

  try {
    return buildMediaSourceResult({ url: audioUrl }, musicItem, quality);
  } catch (primaryError) {
    console.warn('[lxKwPluginClient] 长青线路获取失败，回退官方酷我客户端:', primaryError.message);
    return kwPluginClient.getMediaSource(musicItem, quality);
  }
}

async function getLyric(musicItem, options = {}) {
  if (options.cachedLyric) {
    return options.cachedLyric;
  }

  try {
    const result = await getMediaSource(musicItem, 'high');
    if (result.lyric) {
      return result.lyric;
    }
  } catch (error) {
    console.warn('[lxKwPluginClient] 长青线路获取歌词失败，回退官方酷我客户端:', error.message);
  }

  return kwPluginClient.getLyric(musicItem, options);
}

const lxKwPluginClient = {
  platform: PLATFORM,
  version: '1.2.0',
  search,
  getMediaSource,
  getLyric
};

export default lxKwPluginClient;
